import { ResponsibleContact } from 'ui/components';

export const ResponsibleContactFeature: React.FC<Umbraco.ResponsibleContact> = ({ content }) => {
	return <ResponsibleContact {...content?.properties} />;
};
